import { Box } from "@mui/system";
import ModalTrigger from "../Common/ModalTrigger";

import BovineBlue from "../../Assets/Bovine-bl.svg";
import CarrotsBlue from "../../Assets/Carrots-bl.svg";
import CauliflowerBlue from "../../Assets/Cauliflower-bl.svg";
import DriedBeansBlue from "../../Assets/Driedbeans-bl.svg";
import KiwiBlue from "../../Assets/Kiwi-bl.svg";
import OnionsBlue from "../../Assets/Onions-bl.svg";
import OrangesBlue from "../../Assets/Oranges-bl.svg";
import PearsBlue from "../../Assets/Pears-bl.svg";
import PotatoesBlue from "../../Assets/Potatoes-bl.svg";
import PoultryBlue from "../../Assets/Poultry-bl.svg";
import RiceBlue from "../../Assets/Rice-bl.svg";
import RyeBlue from "../../Assets/Rye-bl.svg";
import GrapesBlue from "../../Assets/GrapesBlue.svg";

const data = [
  {
    filter: "Bovine liver",
    image: BovineBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 1,015 samples of bovine liver were analysed. In 99.8% (1,013) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
              were found. In 0.1% (1) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            ;{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            samples were not reported.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 0.1% (1) of samples. For one bovine liver sample from the EU, two different pesticides were reported: bifenthrin and dieldrin. The results were within the permissible levels.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Carrots",
    image: CarrotsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
           A total of 1,027 samples of carrots were analysed. In 66.1% (679) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 2.4% (25) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.5% (15) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 16.5% (169) of samples. In one carrot sample grown in the EU, 10 different pesticides were reported: azoxystrobin, boscalid, difenoconazole, dithiocarbamates, fludioxonil, fluopyram, fluxapyroxad, lambda-cyhalothrin, paclobutrazol and pendimethalin. All the results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Cauliflowers",
    image: CauliflowerBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 865 samples of cauliflowers were analysed. In 86.2% (746) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 0.9% (8) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.6% (5) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
           were reported in 1.6% (14) of samples. In one cauliflower sample grown in the EU, five different pesticides were reported: azoxystrobin, difenoconazole, flonicamid, fluopyram and tebuconazole. All the results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Kiwi fruits",
    image: KiwiBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 850 samples of kiwi fruits (green, red, yellow) were analysed. In 58.6% (498) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 1.5% (13) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.8% (7) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          {/* <p className='paragraph'>
						The reporting countries flagged the issue of high{' '}
						<ModalTrigger
							style={{ color: '#22294D', cursor: 'pointer' }}
							text='MRL exceedance rates'
						/>{' '}
						in grapefruits from third countries in 2021. As a result, in
						December 2021 the European Commission increased border controls on
						this food commodity.
					</p> */}
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 16.2% (138) of samples. In one kiwi fruit sample grown in the EU, five different pesticides were reported: boscalid, etofenprox, fosetyl, lambda-cyhalothrin and tebuconazole. All the results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Onions",
    image: OnionsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 1,098 samples of onions were analysed. In 76.0% (834) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
              were found. In 0.8% (9) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.4% (4) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
              were reported in 6.6% (73) of samples. In three onion samples (one grown in the EU and the other two in New Zealand), 10 different pesticide residues were reported. All three samples were compliant with the legal limit. The pesticides found in the EU sample were: boscalid, chlorantraniliprole, deltamethrin, fluopicolide, fosetyl, pendimethalin, propamocarb, pyraclostrobin, tebuconazole and trifloxystrobin. The pesticides found in the samples from third countries were: boscalid, cyprodinil, dimethomorph, fenamidone, fipronil, fluopyram, fluxapyroxad, fosetyl, imidacloprid, iprodione, maleic hydrazide, pendimethalin, pyrimethanil and thiamethoxam.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Oranges",
    image: OrangesBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 1,106 samples of oranges were analysed. In 23.2% (257) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 2.4% (26) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.2% (13) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
              were reported in 64.3% (711) of samples. In one orange sample grown in the EU, 12 different pesticides were reported: acetamiprid, fenpyroximate, fosetyl, hexythiazox, imazalil, lambda-cyhalothrin, metalaxyl and metalaxyl-M, pendimethalin, pyridaben, pyrimethanil, pyriproxyfen and tau-fluvalinate. All the results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Pears",
    image: PearsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
           A total of 1,128 samples of pears were analysed. In 21.3% (240) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 3.2% (36) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.6% (18) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
              were reported in 64.8% (731) of samples. In two pear samples, (one grown in the EU and the other in Türkiye), 14 different pesticides were reported. In the EU sample the pesticides reported were: boscalid, captan, chlorantraniliprole, cyprodinil, difenoconazole, dithianon, dodine, fludioxonil, fluopyram, fluxapyroxad, fosetyl, pyraclostrobin pyrimethanil and tebufenozide. All the results were within the permissible level.
          </p>
           <p>
          In the second sample from a third country the following pesticides were reported: abamectin, acetamiprid, captan, deltamethrin, difenoconazole, diflubenzuron, dithiocarbamates, fosetyl, lambda-cyhalothrin, pyrimethanil, pyriproxyfen, spinetoram, spirodiclofen and tebuconazole. This lot was not released on the market and resulted in penalties.
        </p>
        </p>
       
      </Box>
    ),
  },
  {
    filter: "Potatoes",
    image: PotatoesBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 1,329 samples of potatoes were analysed. In 72.2% (959) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 1.4% (18) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.8% (10) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 6.1% (81) of samples. In three potato samples grown in the EU, four pesticides were reported: azoxystrobin, flonicamid, fosetyl, imazalil, mandipropamid, metalaxyl and metalaxyl-M and propamocarb. The residue levels were all within the permissible levels, except in one of the samples where imazalil was reported. This sample lot was destroyed.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Dried beans",
    image: DriedBeansBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 798 samples of dried beans were analysed. In 69.0% (551) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 6.9% (55) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 3.5% (28) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
              were reported in 10.7% (85) of samples. In one dried bean sample coming from Madagascar, six different pesticides were reported: acetamiprid, chlorpyrifos, cypermethrin, fosetyl, methomyl and thiodicarb. The sample was non-compliant, but action taken was not reported.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Poultry fat",
    image: PoultryBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
           A total of 2,405 samples of poultry fat were analysed. In 99.1% (2,384) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. Samples{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeding the MRL"
            />{" "}
            or{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />
            {" "}were not reported.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
           were reported in 0.1% (3) of samples. For one poultry fat sample from the EU, eight different pesticides were reported: chlordane, DDT, endosulfan, heptachlor, hexachlorobenzene, hexachlorocyclohexane, alpha-, hexachlorocyclohexane, beta- and lindane. The results were within the permissible levels.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Rice",
    image: RiceBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 971 samples of rice were analysed. In 62.2% (604) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 5.1% (50) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 3.4% (33) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 18.1% (176) of samples. In one rice sample coming from India, 10 different pesticides were reported: azoxystrobin, bromide Ion, chlorpyrifos, clothianidin, imidacloprid, isoprothiolane, malathion, tebuconazole, thiamethoxam and tricyclazole. This result was non-compliant due to chlorpyrifos. The sample lot was recalled from the market, a RASFF notification issued, and penalties taken.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Rye",
    image: RyeBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
           A total of 654 samples of rye were analysed, of which 235 were of wholemeal flour. In 74.6% (488) of samples, no{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found. In 0.8% (5) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.3% (2) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 9.5% (62) of samples. For one rye sample grown in the EU, five different pesticide residues  were reported: chlormequat chloride, cypermethrin, dithiocarbamates, mepiquat chloride and pirimiphos - methyl. All the results were within the permissible levels.
          </p>
        </p>
      </Box>
    ),
  },

];

const Intro = (props) => {
  const found = data.find((d) => d.filter === props.name);

  if (!found) {
    console.error(`No match found for ${props.name}`);
    return <div>No data available for this commodity.</div>;
  }

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box>
        <img
          loading="lazy"
          class="img-fluid"
          alt="commodity icon"
          src={found.image}
          style={{ width: "50px" }}
        ></img>
      </Box>
      <p
        style={{
          textTransform: "uppercase",
          marginBottom: "0",
          color: "#22294D",
          fontSize: "10px",
        }}
      >
        Detailed results
      </p>
      <h3 style={{ fontSize: "24px" }}>{props.name}</h3>
      {found && found.body}
    </Box>
  );
};


export default Intro;
